import { jsx as _jsx } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import HomeSectionLayout from "../components/HomeSectionLayout";
import PromotionBanner from "../components/PromotionBanner";
const FreePromotion = (param)=>{
    let { content , entityId , homeId  } = param;
    var _content_, _content_1, _content_2, _content_3, _content_4, _content_5, _content__items;
    // MX-373: PR 섹션 전체보기 버튼 트래킹
    const handleCtaClick = ()=>{
        var _content_, _content_1;
        mixpanelEvent("[Home] PR Section Clicked", {
            "Entity Id": entityId,
            "Home Id": homeId,
            Type: "전체보기 버튼",
            "Button Name": (_content_ = content[0]) === null || _content_ === void 0 ? void 0 : _content_.ctaButtonName,
            "Button URL": (_content_1 = content[0]) === null || _content_1 === void 0 ? void 0 : _content_1.ctaButtonLink
        });
    };
    // MX-373: PR 섹션 아이템 버튼 트래킹
    const handleItemClick = (item)=>{
        mixpanelEvent("[Home] PR Section Clicked", {
            "Entity Id": entityId,
            "Home Id": homeId,
            "Item Id": item.itemOrder,
            Type: "아이템 버튼",
            "Button Name": item.buttonLabel,
            "Button URL": item.buttonLink
        });
    };
    var _content__title;
    return /*#__PURE__*/ _jsx(HomeSectionLayout, {
        title: (_content__title = (_content_ = content[0]) === null || _content_ === void 0 ? void 0 : _content_.title) !== null && _content__title !== void 0 ? _content__title : "",
        header: (_content_1 = content[0]) === null || _content_1 === void 0 ? void 0 : _content_1.header,
        isUseButton: Boolean((_content_2 = content[0]) === null || _content_2 === void 0 ? void 0 : _content_2.ctaButtonLink),
        buttonText: (_content_3 = content[0]) === null || _content_3 === void 0 ? void 0 : _content_3.ctaButtonName,
        buttonUrl: (_content_4 = content[0]) === null || _content_4 === void 0 ? void 0 : _content_4.ctaButtonLink,
        onCtaClick: handleCtaClick,
        children: /*#__PURE__*/ _jsx("ul", {
            className: "scrollbar-hide flex gap-5 overflow-x-scroll max-lg:px-8 max-sm:gap-3 max-sm:px-5",
            children: content[0] && ((_content_5 = content[0]) === null || _content_5 === void 0 ? void 0 : (_content__items = _content_5.items) === null || _content__items === void 0 ? void 0 : _content__items.map((item)=>/*#__PURE__*/ _jsx("li", {
                    children: /*#__PURE__*/ _jsx(PromotionBanner, {
                        ...item,
                        onButtonClick: ()=>handleItemClick(item)
                    })
                }, item.itemOrder)))
        })
    });
};
export default FreePromotion;
